import { Box, Button, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { BiLogOut } from 'react-icons/bi';
import { useAuth } from 'src/utils/auth';
import useRequest from 'src/utils/hooks/useRequest';
import { CoverLoader } from 'src/components/atoms';
import { useRouter } from 'next/router';
import * as Sentry from '@sentry/react';

const AdminRouteRedirect = () => {
  const { isAuthenticated, logout, user } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const { api } = useRequest();
  const router = useRouter();

  useEffect(() => {
    const fetchOnboardingChecklist = async () => {
      try {
        const response = await api.marketingOnboarding.checklist.get();
        if (response && response.user && !response.marketplace_id) {
          // the user is in the onboarding process, so send them there to continue
          // the onboarding logic will handle the rest
          router.push('/onboarding/signup');
        } else {
          // otherwise, show them the message and logout button
          setIsLoading(false);
        }
      } catch (error) {
        Sentry.captureException(error, {
          tags: {
            component: 'AdminRouteRedirect',
            userId: user?.id,
          },
          extra: {
            errorMessage: error?.message || 'Failed to load onboarding checklist',
          },
        });
        setIsLoading(false);
      }
    };
    if (isLoading && isAuthenticated) {
      fetchOnboardingChecklist();
    }
  }, [isLoading, isAuthenticated]);

  const handleLogout = async () => {
    const loggedOut = await logout();
    if (loggedOut) {
      window.location.href = '/';
    }
  };

  if (isLoading) {
    return <CoverLoader context="AdminRouteRedirect:CheckingOnboarding" />;
  }

  // this is the fallback for when the user is logged in, no affiliate marketplace found, no onboarding checklist found
  return (
    <VStack spacing={6} textAlign="center">
      <Box pt={10} px={4} textAlign="center">
        If you are an admin, please go to the &quot;Admin Settings&quot; tab directly on your site.
      </Box>
      <Button
        variant="outline"
        onClick={handleLogout}
        fontSize="sm"
        leftIcon={<BiLogOut />}
        colorScheme="primary"
      >
        Log Out
      </Button>
    </VStack>
  );
};

export default AdminRouteRedirect;
